import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { AuthService } from '../../services/auth.service';

import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';
import { LoggerService } from '../../../logging/logger.service';
import config from '../../../../../config.js';

interface SessionLike {
  tokens?: unknown;
}

@Component({
  selector: 'app-login',
  imports: [SpinnerComponent],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnDestroy, OnInit {
  private unsubscribe: Subscription[] = [];
  isAuthenticating = false;
  hasSession = false;
  errorMessage: string | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private logger: LoggerService,
  ) {}

  ngOnInit(): void {
    this.authService
      .amplifyGetUserSession()
      .pipe(first())
      .subscribe({
        next: (session: SessionLike) => {
          if (session?.tokens) {
            this.hasSession = true;
            this.router.navigate(['/home']);
          }
        },
        error: (e) => {
          this.logger.warn?.('LoginComponent session check failed', e);
        },
      });
  }

  manualLogin(): void {
    if (this.isAuthenticating) return;
    if (!this.hasCognitoConfig()) {
      this.errorMessage = 'Missing Cognito configuration.';
      return;
    }
    this.errorMessage = null;
    this.isAuthenticating = true;
    const sub = this.authService
      .loginSSO('AzureAD')
      .pipe(first())
      .subscribe({
        error: (err) => {
          this.errorMessage = 'Login failed';
          this.logger.error('Manual login failed', err);
          this.isAuthenticating = false;
        },
      });
    this.unsubscribe.push(sub);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((obs) => obs.unsubscribe());
  }

  private hasCognitoConfig(): boolean {
    return Boolean(
      config.AWS_COGNITO_USER_POOL_ID &&
      config.AWS_COGNITO_CLIENT_ID &&
      config.AWS_REGION &&
      (config.AWS_COGNITO_CLIENT_DOMAIN || config.APP_DOMAIN_ENDPOINT),
    );
  }
}
